import { colors } from '@chegg-ui/theme'
import { IconButtonProps as OGIconButtonProps } from '@chegg-ui/button'
import { QuickActionButton } from '../styled'
import { ParaphraseIcon, ExpandIcon, ShortenIcon, SynonymIcon } from '../../icons'

export type IconButtonProps = Omit<
  OGIconButtonProps,
  'screenReaderOnlyText' | 'children'
> & {}

export const SynonymsIconButton = ({ onClick, ...rest }: IconButtonProps) => (
  <QuickActionButton onClick={onClick} screenReaderOnlyText="synonyms" {...(rest as any)}>
    <>
      <SynonymIcon color={colors.grey900} /> <span>Synonyms</span>
    </>
  </QuickActionButton>
)

export const ParaphraseIconButton = ({ onClick, ...rest }: IconButtonProps) => (
  <QuickActionButton
    onClick={onClick}
    screenReaderOnlyText="paraphrase"
    {...(rest as any)}
  >
    <>
      <ParaphraseIcon /> <span>Paraphrase</span>
    </>
  </QuickActionButton>
)

export const ExpandIconButton = ({ onClick, ...rest }: IconButtonProps) => (
  <QuickActionButton onClick={onClick} screenReaderOnlyText="expand" {...(rest as any)}>
    <>
      <ExpandIcon /> <span>Expand</span>
    </>
  </QuickActionButton>
)

export const ShortenIconButton = ({ onClick, ...rest }: IconButtonProps) => (
  <QuickActionButton onClick={onClick} screenReaderOnlyText="shorten" {...(rest as any)}>
    <>
      <ShortenIcon /> <span>Shorten</span>
    </>
  </QuickActionButton>
)
